import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { logout } from "../../../features/auth";
import type { ICustomMap } from "../../../models/storeModels/ICustomMap";

function getInitialState(){
    const initialState: ICustomMap = {
        customMapFiltersState: undefined,
        customMapAppliedFilters: undefined,
        customMapFilterString: undefined,
    }
    return initialState;
}

export const customMapSlice = createSlice({
    name: 'customMap',
    initialState: getInitialState(),
    reducers: {
        setCustomMapFiltersState(state, action: PayloadAction<any>) {
            state.customMapFiltersState = action.payload
        },
        setCustomMapAppliedFilters(state, action: PayloadAction<any>) {
            state.customMapAppliedFilters = action.payload
        },
        setCustomMapFilterString(state, action: PayloadAction<any>) {
            state.customMapFilterString = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return getInitialState()
        })
    },
})

export const {
    setCustomMapFiltersState,
    setCustomMapAppliedFilters,
    setCustomMapFilterString,
} = customMapSlice.actions
export const customMapReducer = customMapSlice.reducer;
